export const environment = {
  production: true,
  // apiUrl: "https://gw.aksiget.hr:50000",
  // apiUrl: "https://192.168.0.20:5000",
  apiUrl: "https://api.inventura.aksiget.hr"
  // apiUrl: 'http://localhost:5000'
};
